// extracted by mini-css-extract-plugin
module.exports = {"title":"confirm-modal_title__1grGS","description":"confirm-modal_description__28n_b"};